import React from "react";
// import { Link } from "gatsby";
import { useLocation } from "@reach/router";
import Contact from "../Contact"
import style from "./Footer.module.css"

const ContactInfo = () =>
    <div className="uk-width-1-2@m uk-flex-first@m">
        <h4 className="h4__large uk-margin-remove">MC+A</h4>
        <p className="uk-text-large uk-text-bold">Let's talk about your business.</p>
        <p>We are always interested in discussing search and insight technology and how it is vital to connecting business intelligence. Our team is happy to discuss how we can help you achieve success. The more information you share, the better we'll be prepared and able to help. </p>
        <div className="uk-grid uk-grid-small uk-flex-top uk-margin-top">
            <div className="auto">
                <span data-uk-icon="icon: phone; ratio: 1.2" />
            </div>
            <div className="uk-width-expand">+1 (312) 585-6396</div>
        </div>
        <div className="uk-grid uk-grid-small uk-flex-top uk-margin-top">
            <div className="auto">
                <span data-uk-icon="icon: location; ratio: 1.2" />
            </div>
            <div className="uk-width-expand">332 S Michigan Ave. 9th FL<br />Chicago, IL 60611</div>
        </div>
        <div className="uk-flex uk-flex-middle uk-flex-between uk-width-2-3@s uk-margin-medium-top">
            <a href="https://www.twitter.com/mcplusa/" className="uk-icon-button" target="_blank" rel="noopener noreferrer nofollow" data-uk-icon="twitter" />
            <a href="https://www.facebook.com/mcplusa/" className="uk-icon-button" target="_blank" rel="noopener noreferrer nofollow" data-uk-icon="facebook" />
            <a href="https://www.linkedin.com/company/mc-a/" className="uk-icon-button" target="_blank" rel="noopener noreferrer nofollow" data-uk-icon="linkedin" />
            <a href="https://www.youtube.com/channel/UCQ9sTx10CW9sFkICETmtl4A/" className="uk-icon-button" target="_blank" rel="noopener noreferrer nofollow" data-uk-icon="youtube" />
            <a href="https://www.mcplusa.com/feed/" className="uk-icon-button" target="_blank" rel="noopener noreferrer nofollow" data-uk-icon="rss" />
        </div>
    </div>

const Footer = () => {
    // const { pathname } = useLocation()
    return (
        <section className={`${style.footerContent} uk-background-secondary`}>
            <div className="uk-container uk-container-xlarge">
                <div className="uk-container uk-container-medium uk-margin-xlarge-top">
                    <div className="uk-grid uk-grid-large uk-light">
                        <ContactInfo />
                        <div className="uk-width-expand uk-flex-first">
                            <Contact />
                        </div>
                    </div>
                </div>
            </div>
            <div className="uk-container uk-container-xlarge uk-background-secondary">
                <div className="uk-container uk-container-small uk-padding-remove-bottom uk-margin-remove-bottom">
                    <div className="uk-text-center uk-padding uk-padding-remove-horizontal uk-light">
                        <small>&copy; 2018-{new Date().getFullYear()} <a href="https://mcplusa.com">MC+A.</a> All Rights Reserved.</small>
                    </div>
                </div>
            </div>
        </section>
    )
}
export default Footer;
